(function($) {
    // Wait for images to load (especially the header image) before calculating the distance from the top
    $(window).on("load", function() {

        if ($('#tabBlock').length) {
            var siteHeader       = $('#siteHeader');
            var siteContent      = $('#site-main');
            var siteHeaderHeight = $(siteHeader).outerHeight();

            var tabNavItem       = $('#tabBlock .tab-nav');
            var tabNavs          = $('#tabBlock').outerHeight();
            var combinedHeight   = siteHeaderHeight + tabNavs;

            // Calculate the vertical locations to "stick" and "release" the tab headers
            var stickySidebarDesktop        = $('#tabBlock').offset().top - 117;
            var stickySidebarMobile         = $('#tabBlock').offset().top - 72;
            var releaseStickySidebarDesktop =        stickySidebarDesktop + 1100;
            var releaseStickySidebarMobile  =         stickySidebarMobile + 1300;

            // Sticky tab navigation
            $(window).scroll(function() {
                if ($(window).width() > 992) {
                    if (($(window).scrollTop() > stickySidebarDesktop)) {
                        tabNavItem.addClass('is-sticky');
                        siteContent.css('padding-top', '190px');
                    } else {
                        tabNavItem.removeClass('is-sticky');
                        siteContent.css('padding-top', 0);
                    }

                    // On desktop hide the tab headers after scrolling past the tab content
                    if ($(window).scrollTop() > releaseStickySidebarDesktop) {
                        tabNavItem.fadeOut();
                    } else {
                        tabNavItem.fadeIn();
                    }

                } else {
                    if ($(window).scrollTop() > stickySidebarMobile) {
                        tabNavItem.addClass('is-sticky');
                        siteContent.css('padding-top', '155px');
                    } else {
                        tabNavItem.removeClass('is-sticky');
                        siteContent.css('padding-top', 0);
                    }

                    // On mobile hide the tab headers after scrolling past the tab content
                    if ($(window).scrollTop() > releaseStickySidebarMobile) {
                        tabNavItem.fadeOut();
                    } else {
                        tabNavItem.fadeIn();
                    }
                }
            });

            // Scroll target panel into view when active
            $('#tabBlock').on('shown.bs.collapse', function () {
                var tabTarget = $(this).attr('data-target');

                if ($(window).width() > 992) {
                    if ($(window).scrollTop() > stickySidebarDesktop) {
                        $('html, body').animate({
                            scrollTop: $('#tabBlock .panel-collapse.show').offset().top - 300
                        }, 500);
                    } else {
                        $('html, body').animate({
                            scrollTop: $('#tabBlock .panel-collapse.show').offset().top - 490
                        }, 500);
                    }
                } else {
                    $('html, body').animate({
                        scrollTop: $('#tabBlock .panel-collapse.show').offset().top - 210
                    }, 500);
                }
            });
        }
    });
}(jQuery));
